import { Heading } from '@lmc/ui-kit'
import type { FC } from 'react'
import styled from 'styled-components'

type Props = { title: string; onClick?: () => void }

export const CardTitle: FC<Props> = ({ title, onClick }) => (
  <HeadingContainer onClick={onClick}>
    <StyledHeading level={4}>{title}</StyledHeading>
  </HeadingContainer>
)

const HeadingContainer = styled.div<{ onClick?: () => void }>`
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'inherit')};
  margin-bottom: 0;
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  font-weight: 700;
`
